module.exports = __webpack_public_path__ + "img/kangmingjian_img12.10dd0a10.jpg";